/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/${metaData}`, payload)
      .then((response) => response.data.queryResult)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/${metaData}`, payload)
      .then((response) => response.data.queryResult)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadActivitiesDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/activities/get-all-data${
        destinations !== undefined ? destinations : ""
      }`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadCabDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/cab-tariff/get-all-data${
        destinations !== undefined ? destinations : ""
      }`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadStateActivitiesDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/activities/get-state-data${
        destinations !== undefined ? destinations : ""
      }`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadCityActivitiesDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/activities/get-city-data${
        destinations !== undefined ? destinations : ""
      }`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadAreaActivitiesDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/activities/get-area-data${
        destinations !== undefined ? destinations : ""
      }`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadSimilarAreaPackagesDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/activities/get-similar-destination-packages${
        destinations !== undefined ? destinations : ""
      }`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadActivitiesReviewsDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(
      `/review/get-all-data${destinations !== undefined ? destinations : ""}`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadSingleActivitiesReviewsDetails(destinations) {
  //const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(`/review/get-one/${destinations !== undefined ? destinations : ""}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadActivitiesDetails,
  loadStateActivitiesDetails,
  loadCityActivitiesDetails,
  loadAreaActivitiesDetails,
  loadActivitiesReviewsDetails,
  loadSingleActivitiesReviewsDetails,
  loadSimilarAreaPackagesDetails,
  loadRecordsMetaData,
  loadCabDetails,
};

export default remotes;
